import cn from '@propertypal/shared/src/utils/cn';
import React, { useEffect, useRef } from 'react';
import StyledError from '../_styles/StyledError';

interface PropertyPalErrorProps {
  isVisible: boolean;
  error: string | undefined;
  margin?: string;
  scrollToError?: boolean;
  className?: string;
}

const PropertyPalError = (props: PropertyPalErrorProps) => {
  const { isVisible, error, margin, scrollToError } = props;
  const ref = useRef<HTMLDivElement>(null);
  const isBrowser = () => typeof window !== 'undefined';

  useEffect(() => {
    if (isBrowser() && ref && ref.current && ref.current.offsetTop) {
      if (scrollToError && isVisible) {
        global.window.scrollTo({
          top: ref.current.offsetTop - 100,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }, [isVisible]);

  return (
    <div ref={ref}>
      {error && error.length > 0 && isVisible ? (
        <StyledError data-testid="styled-error" margin={margin} className={cn('pp-input-error-label', props.className)}>
          {error}
        </StyledError>
      ) : null}
    </div>
  );
};

export default PropertyPalError;
